"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseVariables = exports.stringContainsVariable = void 0;
const stringContainsVariable = (str) => /\{\{(.*?)\}\}/g.test(str);
exports.stringContainsVariable = stringContainsVariable;
const parseVariables = (text, variables) => {
    if (text === "")
        return text;
    return text.replace(/\{\{(.*?)\}\}/g, (_, fullVariableString) => {
        var _a;
        let variableString = fullVariableString.replace(/{{|}}/g, "");
        const isMathFormula = ["*", "/", "+", "-"].some((val) => variableString.includes(val));
        const matchedVariables = [
            ...variables.questionVariables,
            ...variables.starterVariables,
            ...variables.computationVariables,
            ...((_a = variables.httpRequestVariables) !== null && _a !== void 0 ? _a : []),
        ].filter((variable) => {
            if (isMathFormula)
                return variableString.includes(variable.name);
            return variableString === variable.name;
        });
        if (matchedVariables.length === 0)
            return "";
        matchedVariables.forEach((variable, idx) => {
            var _a;
            const hasValueInFurtherMatchedVariable = !variable.value &&
                matchedVariables
                    .slice(idx)
                    .find((v) => v.name === variable.name && v.id !== variable.id);
            if (hasValueInFurtherMatchedVariable)
                return;
            variableString = variableString.replace(new RegExp(variable.name, "g"), (_a = variable.value) !== null && _a !== void 0 ? _a : "");
        });
        if (isMathFormula) {
            variableString = replaceCommasWithDots(variableString);
            try {
                const evaluatedNumber = eval(variableString);
                return evaluatedNumber.toString();
            }
            catch (err) {
                return variableString;
            }
        }
        return variableString !== null && variableString !== void 0 ? variableString : "";
    });
};
exports.parseVariables = parseVariables;
const replaceCommasWithDots = (str) => str.replace(new RegExp(/(\d+)(,)(\d+)/, "g"), "$1.$3");
//# sourceMappingURL=variables.js.map